import React, { useState, useRef, useEffect } from "react";
import arrow from "../../../../../assets/images/arrow.png";
import startupsvg from "../../../../../assets/svg/dashboard/startup_application.svg";
import GlobalDropDown2 from "../../AdminDashboard/GlobalDropDown2";
import "./style.scss";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";

import {
  getMentorMyRequest,
  getMentorStartUpApplicationList,
  setMentorStartUpStatus,
  getCountersMentorList,
} from "../dependencies/action";
import { useHistory } from "react-router-dom";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import {
  getPredefineOptionsList,
  getNamesList,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import LineWithDot from "../MentorHome/img/Line wit Dot.svg";
import Pagination from "react-js-pagination";
import { updateApplicationStatus } from "../../AdminDashboard/ViewApplication/dependencies/action";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as moment from "moment";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import Button from "../../AdminDashboard/Button";
import swal from "sweetalert";
import api from "../../../../common/dependencies/utils/Api";
import {
  GET_A_MENTOR_DATA,
  MENTORSHIP_STARTUP_APPLICATION_STATUS,
} from "../../../../common/constants/ApplicationUrl";
import thirdSidebarIcon from "../../../../../assets/svg/dashboard/thirdSidebarStartup.svg";

import mentorshipIcon from "../../../../../assets/svg/cohort_program_icon.svg";
import engagementIcon from "../../../../../assets/svg/ mentroshipsMiniCircle.svg";

const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    maxWidth: "225px",
    // color: "#333",
    color: "rgb(121, 193, 206)",
    whiteSpace: "nowrap",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
      whiteSpace: "nowrap",
      textAlign: "left",
    };
  },
};

const approvalOptions = [
  {
    value: "Accept",
    label: "Accept",
  },
  { value: "Decline", label: "Decline" },
];
const MyRequestAction = (props) => {
  let value = localStorage.getItem("SavedLoggedInData");
  let LoginData = JSON.parse(value);
  const {
    getMentorMyRequest,
    DashboardMentorMyRequestList,
    getPredefineOptionsList,
    getPredefineOptions,
    getMentorStartUpApplicationList,
    setMentorStartUpStatus,
    getListData,
    getListDataPaginate,
    getCountersMentorList,
    getCounterMentor,
    getNamesList,
    getNamesListData,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const [indexCounter, setIndexCounter] = useState(0);
  const [activeText, setActiveText] = useState(true);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [sortField, setSortField] = useState("fellowName");
  const [sortOder, setSortOrder] = useState("DESC");
  const [activePage, setActivePage] = useState(1);
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [action, setAction] = useState();
  const [approvaloption, setApprovalOption] = useState("");
  const [submitData, setSubmitData] = useState();
  const [tableData, setTableData] = useState();
  const [rowStatus, setRowStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const history = useHistory();
  const selectOptions = {};
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [filterName, setFilterName] = useState("");
  const [nameListValue, setNameListValue] = useState([]);
  const newCountryArray = [];
  const newStateArray = [];
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const html = document.getElementsByTagName("html")[0];
  const [selectedRow, setSelectedRow] = useState("");

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor" && !localStorage.getItem("setloggedin")) {
    localStorage.setItem("myrequestMenu", "myrequestMenu");
  } else if (loginrole === "Mentor" && localStorage.getItem("setloggedin")) {
    localStorage.removeItem("myrequestMenu");
  } else {
    localStorage.removeItem("myrequestMenu");
    history.push("/startup-dashboard");
  }
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  useEffect(() => {
    // localStorage.setItem("myrequestMenu", "myrequestMenu");
    html.style.overflow = "auto";

    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortApplicationMentor");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
      localStorage.removeItem("CohortGroupSession");
    }, 1000);
    let params = {
      mentorId: LoginData.id,
    };

    getCountersMentorList(params);
  }, []);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select State",
        };
        newStateArray.push(arr2);
        setNewStateOptions((oldArray) => [...oldArray, arr2]);
      }
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    let nameArrList = [];
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  const setUpdateApplicationStatus = (status, searchId) => {
    // alert("Test")
    if (status != "Select") {
      let params = {
        searchId: searchId,
        mentorId: LoginData.id,
        status: status,
      };
      api
        .POST(`${MENTORSHIP_STARTUP_APPLICATION_STATUS}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (response === undefined) {
            swal({
              title: "WARNING",
              text: `Failed to  ` + params.status + ` Request `,
              icon: "info",
              // timer: 4500,
              // buttons: false,
            });
            return false;
          }
          if (status === 200) {
            localStorage.setItem("myrequestMenu", "myrequestMenu");
            window.location.reload();
            swal({
              title: "Success",
              text: `Request Accepted Successfully `,
              icon: "success",
              // timer: 2500,
              // buttons: false,
            });
            return response.data;
          } else {
            return { status: false };
          }
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    }
    // setMentorStartUpStatus(params).then((res) => {
    //   alert(res)
    //   if (res) {
    //     if (res) {
    //     }
    //   }
    //   // onClose();
    //   localStorage.setItem("myrequestMenu", "myrequestMenu");
    //   // window.location.reload();
    // });
  };
  const getMentorApplicationTable = (status) => {
    let params = {
      mentorId: LoginData.id,
      status: status,
      searchField: filterName === "Select" ? "" : filterName,
      state:
        formData?.state?.label == "Select State" ? "" : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
      },
    };
    getMentorStartUpApplicationList(params);
  };
  //   const handleStatusChange = async(status, searchId) => {
  //     alert(status.target.value)
  //     if(!status.target.value === "Select"){
  //     // let statusName;
  //     // if(status.target.value === "Decline" ){
  //     //   statusName = "Declined"
  //     // }
  //     // else
  //     //  if(status.target.value === "Accept")
  //     // {
  //     //   statusName = "Accepted"
  //     // }
  //     setApprovalOption(status.target.value);
  //     let params = {
  //       searchId: searchId,
  //       mentorId: LoginData.id,
  //       status: status.target.value,
  //     };
  //     let  response =await(setMentorStartUpStatus(params)) ;
  //     if(response === undefined)
  //     {
  //       localStorage.setItem("myrequestMenu", "myrequestMenu");
  //       setTimeout(()=>{
  //           // window.location.reload();
  //         },100)
  //       // document.body.style.overflow = "hidden"
  //     //      setTimeout(()=>{
  //     //   window.location.reload();
  //     // },5000)
  //         }
  //         else{
  //           setTimeout(()=>{
  //             // window.location.reload();
  //           },100)          // setTimeout(()=>{
  //           //   window.location.reload();
  //           // },300)
  //         }

  //     // if(status.target.value === "Accept")
  //     // {

  //     // }

  //     // setRowStatus(true);
  //   };
  // }
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  useEffect(() => {
    if (history?.location?.state?.prevPage === undefined) {
      setActiveText(true);
      setActiveText2(false);
      getMentorApplicationTable("");
    } else if (history?.location?.state?.prevPage === "mentorDashboard") {
      setActiveText(false);
      setActiveText2(true);
      getMentorApplicationTable("PENDING");
      history.location.state.prevPage = undefined;
    }
  }, []);
  const onclickShowSubmitAction = (action, id, status) => {
    setShowSubmitAction(true);
    setAction(action);
    let params = {
      id: id,
      status: status,
    };
    setSubmitData(params);
  };
  const clickOnClose = () => {
    window.location.reload();
    setShowSubmitAction((x) => !x);
    setShowSubmitAction(!showSubmitAction);
    setApprovalOption("Select");
  };
  // const setUpdateApplicationStatus = (action, id, status) => {
  //   let params = {
  //     id: id,
  //     status: status,
  //     // comments: formData.reason,
  //   };
  //   updateApplicationStatus(params).then((res) => {
  //     alert(res)
  //     if (res) {
  //       if (res) {
  //       }
  //     }
  //     // onClose();
  //     localStorage.setItem("mentorMenu", "mentorMenu");
  //     // window.location.reload();
  //   });
  // };
  const testValue =
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.";
  const defaultFormData = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const defaultFormData2 = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [appliedformData, setAppliedFormData] = useState(defaultFormData2);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const sortCloumn = (name) => {
    if (sortField === name) {
      setSortField(name);
      setSortOrder(sortOder === "DESC" ? "ASC" : "DESC");
    } else {
      setSortField(name);
    }
  };
  const getAppId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      mentorId: LoginData.id,
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getMentorStartUpApplicationList(params);
  };
  const getStartUpListDataNameSearch = (name) => {
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: name === "Select" ? "" : name,
      searchKey: null,
      country: "",
      mentorId: LoginData.id,
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state:
        formData?.state?.label == "Select State" ? "" : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getMentorStartUpApplicationList(params);
    // getStartupApplication(params);
  };
  const getStartupApplicationTable = (status) => {
    setSelectedStatus(status);
    let params = {
      requestedBy: "",
      status: status,
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: null,
      searchKey: null,
      country: "",
      mentorId: LoginData.id,
      searchField: filterName === "Select" ? "" : filterName,
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state:
        formData?.state?.label == "Select State" ? "" : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      // country: "",
      // state: "",
      // industry: "", // optional
      // function: "", // optional
      // stage: "",
    };
    getMentorStartUpApplicationList(params);
    // getStartupApplication(params);
  };
  const handleInputChange = (e, name) => {
    const { value } = e.target;

    setFormData((user) => {
      return { ...user, [name]: value };
    });

    const newFormData = {
      ...formData,
      [name]: value,
    };

    localStorage.setItem(
      "formdataMentorMyrequest",
      JSON.stringify(newFormData)
    );
    setAppliedFormData(newFormData);
  };
  const ViewProfile = (item) => {
    history.push({
      pathname: `/mentor-profile/${item.email}`,
      state: { prevPage: "mentorPage", data: item },
    });
  };
  const ViewMentorApplicaiton = (applicationId) => {
    setIndexCounter(applicationId.id);
    const currentRoute = window.location.href;
    let sample;
    sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
    let reRoute = window.open(
      `/view-StartupApplication/${applicationId}`,
      "_blank"
    );
    reRoute.id = applicationId.dpiitNumber;
    // history.push({
    //   pathname: "/view-StartupApplication",
    //   state: applicationId
    //   // state: {
    //   //   id: applicationId,
    //   //   fromModule: "mentorStartRequest",
    //   // },
    // });
  };
  return (
    <div className="requestFrom-startup menreqstartupmndashmbl">
      <div
        className="dashboard-main reqstartupdiv"
        style={{ background: "none" }}
      >
        <div className="iconWith-heading">
          <div style={{ width: "100%" }}>
            <h3
              className="fadeInDown wow menteedashbord-Firdthead"
              style={{
                color: "#000",
                fontWeight: 600,
              }}
            >
              MAARG Portal by Startup India
            </h3>
            <h3
              className="fadeInDown wow headingmobileview"
              style={{
                // color: "#000",
                // fontWeight: 600,
                fontSize: "16px",
                color: "#563a96",
                fontFamily: "Montserrat",
                marginTop: "10px",
                fontWeight: "600",
                // fontSize: "40px",
              }}
            >
              MENTORSHIP REQUESTS FROM STARTUPS
            </h3>
            <h2
              className="heading fadeInDown wow headingdeskview"
              style={{ fontWeight: "600", marginTop: "10px" }}
            >
              MENTORSHIP REQUESTS FROM STARTUPS
            </h2>
          </div>

          <div
            className="tooltipshow eyeIcon "
            // onClick={() => {
            //   // html.style.overflow = "hidden";
            //   if (html.style.overflow == "auto") {
            //     html.style.overflow = "hidden";
            //   } else {
            //     html.style.overflow = "auto";
            //   }
            // }}
          >
            <div className="newuserTooltip">
              <img
                onClick={() => {
                  setModalIsOpenToTrue();
                  if (html.style.overflow == "auto") {
                    html.style.overflow = "hidden";
                  } else {
                    html.style.overflow = "auto";
                  }
                }}
                className="iconbtn top-btn"
                src={iconTooltip}
                width={60}
              />
              <span
                className="tooltiptext tooltip-bottom "
                style={{ width: "130px", top: "50px", left: "20px" }}
              >
                View Instructions
              </span>
            </div>
          </div>
          {isShown && (
            <div>
              <AnimeList
                setModalIsOpenToTrue={setModalIsOpenToTrue}
                Heading={Heading}
                InstructionswithRole={InstructionswithRole}
                SelectPage={SelectPage}
              />
            </div>
          )}
        </div>
      </div>

      <div className="col-md-11 display-center mobileviewmentorreq">
        <div className="admin-bottom-cardNew row mobileviewmentorbelow">
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
            <div className="dashboard-bottom-btn2">
              <p className="text-white2"> REQUEST STATUS</p>
            </div>
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalReceivedBlock3 newuserTooltip">
            <p
              onClick={() => {
                setActiveText(true);
                setActiveText2(false);
                setActiveText3(false);
                setActiveText4(false);
                // setSelectedStatus("");
                getStartupApplicationTable("");
                // getMentorApplicationTable("");
                // getMentorApplications("");
              }}
              style={{
                color: activeText ? "#277acc" : "#838186",
                position: "relative",
              }}
              className="admindasheaderoptions d-flex justify-content-center"
            >
              REQUESTS RECEIVED :{" "}
              {getCounterMentor && getCounterMentor.total !== null
                ? getCounterMentor.total
                : 0}
              {/* {getCounter && getCounter.total} */}
            </p>
            <span className="tooltiptext   tooltip-bottom mentor-01">
              Click to View Requests Received
            </span>
            {activeText ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalReceivedBlock7 newuserTooltip">
            <p
              onClick={() => {
                setActiveText2(true);
                setActiveText(false);
                setActiveText3(false);
                setActiveText4(false);
                // setSelectedStatus("PENDING");
                getStartupApplicationTable("PENDING");
                // getMentorApplicationTable("PENDING");
                // getMentorApplications("");
              }}
              style={{
                color: activeText2 ? "#277acc" : "#838186",
                position: "relative",
              }}
              className="admindasheaderoptions d-flex justify-content-center"
            >
              PENDING :{" "}
              {getCounterMentor && getCounterMentor.pending !== null
                ? getCounterMentor.pending
                : 0}
              {/* {getCounter && getCounter.total} */}
            </p>
            <span className="tooltiptext   tooltip-bottom mentor-02">
              Click to View Requests Pending
            </span>
            {activeText2 ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalPendingBlock4 newuserTooltip">
            <p
              onClick={() => {
                setActiveText3(true);
                setActiveText(false);
                setActiveText2(false);
                setActiveText4(false);
                // setSelectedStatus("ACCEPTED");
                getStartupApplicationTable("ACCEPTED");
                // getMentorApplicationTable("ACCEPTED");
                // getMentorApplications("PENDING");
              }}
              style={{ color: activeText3 ? "#277acc" : "#838186" }}
              className="admindasheaderoptions"
            >
              {" "}
              REQUESTS ACCEPTED :{" "}
              {getCounterMentor && getCounterMentor.accepted !== null
                ? getCounterMentor.accepted
                : 0}
              {/* {getCounter && getCounter.pending} */}
            </p>
            <span className="tooltiptext   tooltip-bottom startupdash-01">
              Click to View Requests Accepted
            </span>
            {activeText3 ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalPendingBlock5 newuserTooltip">
            <p
              onClick={() => {
                setActiveText3(false);
                setActiveText(false);
                setActiveText2(false);
                setActiveText4(true);
                // setSelectedStatus("REJECTED");
                getStartupApplicationTable("REJECTED");
                // getMentorApplicationTable("REJECTED");
                // getMentorApplications("VERIFIED");
              }}
              style={{ color: activeText4 ? "#277acc" : "#838186" }}
              className="admindasheaderoptions"
            >
              {" "}
              REQUESTS DECLINED :{" "}
              {getCounterMentor && getCounterMentor.rejected !== null
                ? getCounterMentor.rejected
                : 0}
              {/* REQUESTS DECLINED : {getListData && getListData?.data && getListData?.data.length>0?getListData?.data.length:0} */}
              {/* {getCounter && getCounter.approved} */}
            </p>
            <span className="tooltiptext   tooltip-bottom startupdash-01">
              Click to View Requests Declined
            </span>
            {activeText4 ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="filter-row filter-row-common filterDivMentorapp">
          {/* <div className="container"> */}
          <div>
            <form className="formContainer">
              <div className="row desktopFilterRow">
                {/* <div
                      className="col-md-1 filter-text3"
                      style={{
                        alignItems: "center",
                        display: "flex",
                        color: "#838186",
                        fontWeight: "400",
                        height: "40px",
                        fontSize: "18px",
                      }}
                    >
                      Filter by
                    </div> */}
                <div className="col-11 d-flex justify-content-between mentorReqAlignment filter-bigDiv">
                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.value);
                        getStartUpListDataNameSearch(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Search StartUp"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Startup
                    </span>
                  </div>

                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Industry
                    </span>
                  </div>
                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Function
                    </span>
                  </div>

                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="stage"
                      // label="Gender*"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Stage
                    </span>
                  </div>

                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search State
                    </span>
                  </div>
                </div>

                <div className="apply-section d-flex justify-content-end col-1 newuserTooltip">
                  <Button
                    // style={{
                    //   background: "#277acc",
                    // }}
                    // onClick={handleClickOfFilter}
                    onClick={() => getStartupApplicationTable(selectedStatus)}
                    text="GO"
                    className="filter-button top-btn newcoloredbtn startupColorBtn"
                  ></Button>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{
                      left: "46px",
                      width: "126px",
                      height: "48px",
                      top: "42px",
                    }}
                  >
                    Click to Apply Filters
                  </span>
                  {/* <Button
                      icon={<img src={arrow} className="search-icon" />}
                      text=""
                      onClick={() => getMentorApplications(selectedStatus)}
                      className="green-btn filter-btn apply-admin-dashbtn newfilterBtnallmentor"
                    /> */}
                </div>
              </div>

              <div className="row mobileFilterRow">
                <div className="col-md-1 filter-text">Filter by</div>
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="searchBy"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="searchBy"
                    className="col-12 gendermentorinput inputmblresmenreqstrtup"
                    styles={customStyles}
                    value={formData.name}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          name: e.name == "select" ? null : e,
                        };
                      });
                      setFilterName(e.value);
                      getStartUpListDataNameSearch(e.value);
                    }}
                    options={nameListValue.length > 0 ? nameListValue : ""}
                    placeholder="Search StartUp"
                  />
                </div>
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="Industry"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="industry"
                    className="col-12 gendermentorinput inputmblresmenreqstrtup"
                    styles={customStyles}
                    value={formData.industry}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          industry: e.value == "select" ? null : e,
                        };
                      });
                      setFilterIndustry(e.value);
                    }}
                    options={getPredefineOptions?.industry_options}
                    placeholder="Industry"
                  />
                </div>
                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="specialization"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="specialization"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={formData.function}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          function: e.value == "select" ? null : e,
                        };
                      });
                      setFilterFunction(e.value);
                    }}
                    options={getPredefineOptions?._specialisation}
                    placeholder="Function"
                  />
                </div>

                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="stage"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="stage"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={formData.stage}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          stage: e.value == "select" ? null : e,
                        };
                      });
                      setFilterStage(e.value);
                    }}
                    options={getPredefineOptions?.stage_of_startup_options}
                    placeholder="Stage"
                  />
                </div>
                {/* <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="country"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="country"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={formData.country}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          country: e.value == "select" ? null : e,
                        };
                      });

                      setFilterCountry(e.label);

                      if (e.label === "India") {
                        setNewCountrySelect(true);
                      } else {
                        setNewCountrySelect(false);
                      }
                      setNewStateOptions("");
                    }}
                    options={newCountryOptions}
                    placeholder="Country"
                  />
                </div> */}

                <div className="user-type-dropdown col-2 select-box">
                  <Select
                    required={true}
                    id="state"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="state"
                    className="col-12 gendermentorinput inputmblresmenreqstrtup"
                    styles={customStyles}
                    value={formData.state}
                    onChange={(e) => {
                      setFormData((user) => {
                        return {
                          ...user,
                          state: e.value == "select" ? null : e,
                        };
                      });
                      setFilterState(e.value);
                    }}
                    options={newStateOptions}
                    placeholder="State"
                  />
                </div>
                <div
                  className="col-md-1 apply-section "
                  style={{ color: "transparent" }}
                >
                  <Button
                    className="green-btn filter-btn "
                    onClick={() => getStartupApplicationTable(selectedStatus)}
                    text="GO"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="totalTableCount">
          Total Records Found :{" "}
          {getListDataPaginate !== undefined && getListDataPaginate !== null
            ? getListDataPaginate?.totalElements
            : "0"}{" "}
          &lt;
          {getListDataPaginate !== undefined && getListDataPaginate !== null
            ? getListDataPaginate?.currentPage
            : "0"}{" "}
          of{" "}
          {getListDataPaginate !== undefined && getListDataPaginate !== null
            ? getListDataPaginate?.numPages
            : "0"}{" "}
          &gt;{" "}
        </div>
        {/* <div className="totalTableCount">
          Total Records Found: 0 &lt; 0 of 0 &gt;{" "}
        </div> */}
        {getListData && getListData?.data?.length > 0 ? (
          <div
            style={{
              marginTop: "1%",
              marginBottom: "3%",
            }}
          >
            <table
              className="table table-bordered"
              style={{ fontSize: "16px" }}
            >
              <thead>
                <tr>
                  <th
                    style={{ verticalAlign: "middle" }}
                    className="tableJustify fixColumbnWidth4"
                  >
                    No.
                  </th>
                  <th
                    style={{ verticalAlign: "middle" }}
                    className="fixTableHeading"
                    colspan="2"
                  >
                    Startup
                    {/* <br /> Name */}
                  </th>
                  <th>
                    Requirement <br />
                    Id
                  </th>
                  {/* <th>
                  Request
                  <br /> Date
                </th> */}
                  <th style={{ verticalAlign: "middle" }}>Match %</th>
                  <th style={{ width: "30%", verticalAlign: "middle" }}>
                    Purpose of Request
                  </th>
                  <th>
                    Request <br />
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {getListData.data !== null &&
                  getListData.data !== undefined &&
                  getListData?.data.map((item, index) => (
                    <tr
                      key={index}
                      className={
                        item.id === indexCounter ? "purpleBackground" : ""
                      }
                    >
                      {getListDataPaginate.currentPage === 1 ? (
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="matchmenreqstrtupmbl"
                        >
                          {index + 1}
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          {index +
                            1 +
                            10 * (getListDataPaginate.currentPage - 1)}
                        </td>
                      )}
                      {/* <td>{index + 1}</td> */}
                      <td
                        className="menreqstrtupdetaismbl"
                        style={{
                          // flexDirection: "row",
                          display: "flex",
                          // justifyContent: "center",
                        }}
                      >
                        <div
                          className="newuserTooltip"
                          style={{
                            width: "100px",
                            height: "100px",
                            maxWidth: "none",
                            objectFit: "contain",
                          }}
                        >
                          <img
                            src={
                              item.startupImage === null
                                ? hashImage
                                : item.startupImage
                            }
                            onClick={() => {
                              setIndexCounter(item.id);
                              redirectProfile(item.dpiitNumber);
                            }}
                            // src={
                            //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                            // }
                            className="sidebar-dashboard-icon2"
                            style={{
                              width: "100%",
                              cursor: "pointer",
                              height: "100%",
                              // maxWidth: "none",
                              objectFit: "contain",
                            }}
                          />
                          <span
                            className="tooltiptext  tooltip-bottom"
                            style={{
                              left: "50px",
                              top: "88px",
                              width: "150px",
                            }}
                          >
                            View Startup Profile
                          </span>
                          <div
                            style={{
                              flexDirection: "row",
                              // display: "flex",
                              justifyContent: "space-between",
                              height: "100px",
                              textAlign: "right",
                              // maxWidth: "240px",
                              fontWeight: "normal",
                            }}
                            className="strtupmenrqmbldetails"
                          >
                            {" "}
                            <div
                              style={{
                                // cursor: "pointer",
                                alignItems: "center",
                                display: "flex",
                                maxWidth: "240px",
                              }}
                            >
                              {item.startupName}
                            </div>
                            <div
                              className="d-flex justify-content-end newuserTooltip"
                              style={{
                                cursor: "pointer",

                                alignItems: "start",
                                justifyContent: "center",
                                height: "100px",
                                width: "100%",
                                display: "flex",
                              }}
                              onClick={() => {
                                setIndexCounter(item.id);
                                redirectProfile(item.dpiitNumber);
                              }}
                            >
                              <img src={profile} width="40px" />
                              {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-info-circle"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                            </svg> */}
                              <span
                                className="tooltiptext  tooltip-bottom"
                                style={{
                                  left: "20px",
                                  top: "110px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        style={{ minWidth: "300px" }}
                        className="detailstddeskmenreqstrtup"
                      >
                        <div
                          style={{
                            flexDirection: "row",
                            display: "flex",
                            justifyContent: "space-between",
                            height: "100px",
                            // maxWidth: "240px",
                          }}
                        >
                          {" "}
                          <div
                            style={{
                              // cursor: "pointer",
                              alignItems: "center",
                              display: "flex",
                              maxWidth: "240px",
                            }}
                          >
                            {item.startupName}
                          </div>
                          <div
                            className="d-flex justify-content-end newuserTooltip"
                            style={{
                              cursor: "pointer",

                              alignItems: "end",
                              justifyContent: "center",
                              height: "100px",
                              width: "40px",
                              display: "flex",
                            }}
                            onClick={() => {
                              setIndexCounter(item.id);
                              redirectProfile(item.dpiitNumber);
                            }}
                          >
                            <img src={profile} />
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-info-circle"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                            </svg> */}
                            <span
                              className="tooltiptext  tooltip-bottom"
                              style={{
                                left: "20px",
                                top: "110px",
                                width: "150px",
                              }}
                            >
                              View Startup Profile
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="reqidmenreqstrtupmbladmndash">
                        <div
                          className="newuserTooltip reqidmenreqstrtupmbladmndashdiv"
                          style={{ marginTop: "13px", marginBottom: "-10px" }}
                        >
                          <a
                            onClick={() => {
                              // setIndexCounter(index.id);
                              ViewMentorApplicaiton(item?.dpiitNumber);
                              // ViewMentorApplicaiton(item);
                            }}
                            // href="#"
                            className="color-green"
                          >
                            {getAppId(item.searchId)}
                          </a>
                          <span
                            className="tooltiptext  tooltip-bottom"
                            style={{ left: "12px" }}
                          >
                            View Requirement
                          </span>
                        </div>
                        <br />
                        <span
                          // style={{ fontSize: "15px" }}
                          className="reqidmenreqstrtupmbladmndashspan"
                        >
                          {moment(item.requestToMentorDate).format(
                            "DD/MM/YYYY "
                          )}
                          <br />
                          {moment(item.requestToMentorDate).format(" hh:mm A")}
                        </span>
                        {/* {moment(item.requestToMentorDate).format("hh:mm A")} */}
                      </td>
                      {/* <td>{item.searchId}</td> */}
                      {/* <td>
                      {moment(item.requestToMentorDate).format("DD/MM/YYYY")}
                      <br />
                      {moment(item.requestToMentorDate).format("hh:mm A")}
                    </td> */}
                      <td>
                        <div
                          style={{
                            // flexDirection: "row",
                            display: "flex",
                            justifyContent: "left",
                            height: "100px",
                            alignItems: "center",
                            // maxWidth: "240px",
                          }}
                          className="matchmenreqstrtupmbl"
                        >
                          {item?.total_percentage === null ||
                          item?.total_percentage === undefined
                            ? "NA"
                            : item?.total_percentage + " %"}
                        </div>
                      </td>

                      {item?.purposeOfMentorship?.length > 100 ? (
                        <td
                          className="myRequestActionTableFix"
                          style={{ verticalAlign: "middle" }}
                        >
                          <div
                            style={{
                              flexDirection: "column",
                              display: "flex",
                              justifyContent: "left",
                              // height: "110px",

                              // maxWidth: "240px",
                            }}
                            className="myRequestActionTableFix2"
                          >
                            {/* {item?.purposeOfMentorship.substring(0, 100)} */}
                            {/* <div className="tooltipicon">
                              <svg
                                style={{
                                  position: "relative",
                                  top: "0.1rem",
                                  cursor: "pointer",
                                }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-three-dots"
                                viewBox="0 0 16 16"
                              >
                                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                              </svg>
                              <span
                                className="tooltiptext7"
                                style={{ top: "-216px", left: "98px" }}
                              >
                                <h5 style={{ color: "#fff" }}>
                                  Purpose of Request
                                </h5>
                                {item?.purposeOfMentorship}
                              </span>
                            </div> */}
                            <div
                              className="tooltipicon myRequestActionTableFix3 "
                              style={{ cursor: "pointer" }}
                            >
                              {item?.purposeOfMentorship.slice(0, 50)}{" "}
                              {item?.purposeOfMentorship.length > 40 && (
                                <b>...</b>
                              )}
                              <span
                                className="tooltiptext7"
                                style={{ top: "-115px", left: "98px" }}
                              >
                                <h5 style={{ color: "#fff" }}>
                                  Purpose of Request
                                </h5>
                                {item?.purposeOfMentorship}
                              </span>
                            </div>
                          </div>
                        </td>
                      ) : (
                        <td style={{ verticalAlign: "middle" }}>
                          <div
                            style={{
                              // flexDirection: "row",
                              display: "flex",
                              justifyContent: "left",

                              alignItems: "center",
                              // maxWidth: "240px",
                            }}
                            className="matchmenreqstrtupmbl"
                          >
                            {item?.purposeOfMentorship}
                          </div>
                        </td>
                      )}
                      {/* <td>{item?.purposeOfMentorship}
                    </td> */}
                      {item.requestStatus === "Accepted" ? (
                        <td
                          style={{
                            verticalAlign: "middle",
                            position: "relative",
                          }}
                          className="reqstatmenreqmblmentrdash"
                        >
                          <div className="reqstatmenreqmblmentrdash2">
                            {item.requestStatus}
                          </div>{" "}
                          <div
                            className="d-flex justify-content-end newuserTooltip reqstatmenreqmblmentrdash3"
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              padding: "5px",
                              right: "0px",
                              bottom: "0px",
                            }}
                            onClick={() => {
                              // if (item?.mentorshipId !== null) {
                              window.open(
                                `/mentor-dashboard/mentorships/engagement-summary/${item?.mentorshipId}`,
                                "_blank"
                              );
                            }}
                          >
                            {/* <img
                              style={{
                                height: "30px",
                                width: "30px",
                                marginTop: "10px",
                              }}
                              src={mentorshipIcon}
                              alt={item.title}
                            /> */}
                            <img
                              style={{
                                height: "40px",
                                width: "40px",
                                // marginTop: "35px",
                              }}
                              src={engagementIcon}
                              alt={item.title}
                            />
                            <span
                              className="tooltiptext  tooltip-bottom mentorshipToolTipFix"
                              style={{
                                height: "45px",
                                top: "45px",
                                left: "10px",
                                width: "140px",
                              }}
                            >
                              View Engagement Summary
                            </span>
                            {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-info-circle"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                          <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                        </svg> */}
                            {/* <span className="tooltiptext-icon tooltip-bottom-icon mentorshipToolTipFix">
                              View Engagement
                            </span> */}
                          </div>
                        </td>
                      ) : item.requestStatus === "Declined" ? (
                        <td>
                          <div
                            style={{
                              marginTop: "35px",
                            }}
                            className="matchmenreqstrtupmbl"
                          >
                            {item.requestStatus}
                          </div>{" "}
                        </td>
                      ) : (
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="applicationStatusMentorapp myRequestActionTableFix2  "
                        >
                          <div
                            className="rowC newuserTooltip justforspaceonly"
                            style={{ cursor: "pointer" }}
                          >
                            <Select
                              required={true}
                              id="Status"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              type="State"
                              name="Status"
                              className="col-12 variablewidth"
                              styles={customStyles}
                              isSearchable={false}
                              // value={filterData6}
                              onChange={(e) => {
                                setUpdateApplicationStatus(
                                  e.value,
                                  item.searchId
                                );
                              }}
                              options={approvalOptions}
                              placeholder="Select"
                            />
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={{
                                left: "30px",
                                top: "47px",
                                width: "180px",
                              }}
                            >
                              Change Request Status
                            </span>
                          </div>
                        </td>
                      )}
                      {/* {item.requestStatus === "Accepted" ||
                    item.requestStatus === "Declined" ? (
                      <td>{item.requestStatus}</td>
                    ) : (
                      <td className="applicationStatusMentorapp">
                        <div className="rowC">
                        <Select
                            required={true}
                            id="Status"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            type="State"
                            name="Status"
                            className="col-12 "
                            styles={customStyles}
                            // value={filterData6}
                            onChange={(e) => {
                              setUpdateApplicationStatus(e.value, item.searchId);
                            }}
                            options={approvalOptions}
                            placeholder="Select"
                          />
                         
                        </div>
                      </td>
                    )} */}
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="pagination-box">
              {getListData ? (
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={getListDataPaginate?.totalElements}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange.bind(this)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="no-records">No Records Found</div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getListData: state.MentorReducer.MentorApplicationList,
    getListDataPaginate: state.MentorReducer.MentorApplicationList.paginate,
    getCounterMentor: state.MentorReducer.getCountersMentorList.data,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};

export default connect(mapStateToProps, {
  getMentorMyRequest,
  getPredefineOptionsList,
  getMentorStartUpApplicationList,
  setMentorStartUpStatus,
  getCountersMentorList,
  getNamesList,
  getStepperTooltipData,
})(withRouter(MyRequestAction));
